import { gql } from 'graphql-request';

import type { RequestDocument } from 'graphql-request';

export const LANGUAGE_QUERY_FRAGMENT = gql`
  {
    id
    caption
    value
    baseLanguage
    region
    script
    rtl
    handlerHint
    defaultModel {
      id
      internalName
      displayName
      modelId
    }
    isActive
  }
`;

export const ALL_LANGUAGES_QUERY: RequestDocument = gql`
  query {
    allLanguages(first: 100, filter: { isActive: { eq: true } }) ${LANGUAGE_QUERY_FRAGMENT}
  }
`;

export const LANGUAGE_BY_VALUE_QUERY: RequestDocument = gql`
  query getLanguage($value: String!) {
    language(filter: { value: { eq: $value } }) ${LANGUAGE_QUERY_FRAGMENT}
  }
`;
